"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupHeading = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var get_1 = tslib_1.__importDefault(require("lodash/fp/get"));
var react_select_1 = require("react-select");
exports.GroupHeading = function (props) {
    var children = props.children, selectProps = props.selectProps;
    var expandableGroups = selectProps.expandableGroups, isGrouped = selectProps.isGrouped;
    var id = get_1.default('id', props);
    var _a = react_1.useState(false), isExpanded = _a[0], setIsExpanded = _a[1];
    var handleHeaderClick = function (node_id) {
        if (node_id !== '') {
            var node = document.querySelector("#" + node_id);
            if (node && node.parentElement && node.parentElement.parentElement) {
                var nodeGrandparentElement = node.parentElement
                    .parentElement;
                var classes = nodeGrandparentElement.classList;
                setIsExpanded(!isExpanded);
                if (classes.contains('collapsed')) {
                    nodeGrandparentElement.classList.remove('collapsed');
                }
                else {
                    nodeGrandparentElement.classList.add('collapsed');
                }
            }
        }
    };
    return (children !== '' && (react_1.default.createElement(react_1.default.Fragment, null, expandableGroups && isGrouped ? (react_1.default.createElement(StyledGroupHeadingWrapper, { className: "group-heading-wrapper", onClick: function () { return handleHeaderClick(id); } },
        react_1.default.createElement(react_select_1.components.GroupHeading, tslib_1.__assign({ className: "expandable" }, props),
            react_1.default.createElement(StyledIcon, null,
                react_1.default.createElement("i", { className: isExpanded ? 'icon--chevron_down' : 'icon--chevron_right' })),
            react_1.default.createElement(StyledIcon, null,
                react_1.default.createElement("i", { className: isExpanded ? 'icon--folder_open' : 'icon--folder' })),
            react_1.default.createElement(StyledGroupHeadingLabel, null, children)))) : (react_1.default.createElement(react_select_1.components.GroupHeading, tslib_1.__assign({}, props),
        react_1.default.createElement(StyledGroupHeadingLabel, null, children))))));
};
var StyledIcon = styled_components_1.default.span(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  margin-right: 0.8rem;\n"], ["\n  margin-right: 0.8rem;\n"])));
var StyledGroupHeadingWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  margin-left: 0rem;\n"], ["\n  margin-left: 0rem;\n"])));
var StyledGroupHeadingLabel = styled_components_1.default.span(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  line-height: 1.6rem !important;\n  font-size: 1.3rem !important;\n"], ["\n  line-height: 1.6rem !important;\n  font-size: 1.3rem !important;\n"])));
exports.GroupHeading.displayName = 'FOS_ReactSelect_GroupHeading';
var templateObject_1, templateObject_2, templateObject_3;
